import styled from 'styled-components';
import {FieldErrorMessage} from '@chekinapp/ui';

const ErrorMessage = styled(FieldErrorMessage).attrs({
  className: 'error-message kiosko:text-kiosko-xs kiosko:bottom-[-44px]',
})`
  font-family: inherit;
  text-align: left;
  color: #f84b7a;
  white-space: nowrap;
  font-size: 11px;

  span:last-child {
    white-space: inherit;
  }
`;

export {ErrorMessage};
